import { render, staticRenderFns } from "./SendoutgoodsdetailReportDetail.vue?vue&type=template&id=24f87504"
import script from "./SendoutgoodsdetailReportDetail.vue?vue&type=script&lang=js"
export * from "./SendoutgoodsdetailReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports